import React, { useEffect, useCallback, useState} from 'react';
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import {connect} from 'react-redux';

const FreakShifterComponent = ({effect, sequencerEngine}) => { 
    return (
        <div>
         <EffectParameterSlider
            parameter={effect.frequencyParameter}
            min={1}
            lfoEnabled={true}
            max={10000}
            name="Frequency"
            sequencerEngine={sequencerEngine}
            isParameter={true}
          />
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FreakShifterComponent);
